import { render, staticRenderFns } from "./input-certificate-type.vue?vue&type=template&id=05179269"
import script from "./input-certificate-type.vue?vue&type=script&lang=js"
export * from "./input-certificate-type.vue?vue&type=script&lang=js"
import style0 from "./input-certificate-type.vue?vue&type=style&index=0&id=05179269&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports